export type SurveyResponsesColumnKeys =
  | 'index'
  | 'user'
  | 'location'
  | 'page'
  | 'device'
  | 'browser'
  | 'os'
  | 'date'
  | 'statements';

export interface ColumnOption {
  label: string;
  show: boolean;
  isDisabled?: boolean;
  showInPanel?: boolean;
}

export type ColumnOptions<Key extends string> = Record<Key, ColumnOption>;

export type SurveyColumnOptions = ColumnOptions<SurveyResponsesColumnKeys>;

export const COLUMNS_OPTIONS_DEFAULT: SurveyColumnOptions = {
  index: { label: 'index', show: false, showInPanel: true },
  page: { label: 'page', show: true, showInPanel: true },
  date: { label: 'date', show: true, showInPanel: true },
  device: { label: 'device', show: true, showInPanel: true },
  location: { label: 'country', show: true, showInPanel: true },
  browser: { label: 'browser', show: true, showInPanel: true },
  user: { label: 'user', show: true, showInPanel: true },
  os: { label: 'os', show: false, showInPanel: true },
  statements: { label: 'statements', show: false, showInPanel: true },
};

export const COLUMNS_VISIBLE_DEFAULT: Record<SurveyResponsesColumnKeys, boolean> = {
  browser: true,
  date: true,
  device: true,
  index: false,
  location: true,
  os: false,
  page: true,
  statements: false,
  user: true,
};
